/**
 * The geometry a condition panel's virtualized option list is given, shared so the
 * multi-select and tags panels cannot drift apart on it.
 */

/** One search row of the popover's fixed height, which the option list gets back when no box renders. */
const SEARCH_ROW_HEIGHT = 44;

/** The list's height with a single search row above it, selection drawer or not. */
const withOneSearchRow = (hasSelection: boolean) => (hasSelection ? 270 : 330);

export const optionListStyles = ({
  hasSelection,
  searchRows,
}: {
  hasSelection: boolean;
  /** How many search rows the header holds — none, one, or the tags panel's key and value. */
  searchRows: number;
}) => ({
  // The popover's height is fixed, so every search row the header does or does not
  // take is height the list does not or does get.
  height: `${withOneSearchRow(hasSelection) + (1 - searchRows) * SEARCH_ROW_HEIGHT}px`,
  // The list scrolls inside Virtuoso, which puts its scrollbar at the content's
  // edge — pulled out into the panel's gutter so it sits at the panel's edge.
  marginRight: '-24px',
  paddingRight: '24px',
});
